import React from "react";
import { Badge, BadgeColor, Stack } from "sprint-common-web";

import { ContentSource } from "../../../common/types/ContentSource";

export interface ContentSourcesBadgeProps {
    sources: ContentSource[];
    tooltipContent?: string;
}

export const ContentSourcesBadge = ({ sources, tooltipContent }: ContentSourcesBadgeProps): JSX.Element => {
    return (
        <Stack style={{ display: "flex", gap: 4 }}>
            {sources.map((source) => (
                <Badge key={source} text={sourceLabel[source]} color={sourceBadgeColor[source]} tooltipContent={tooltipContent} />
            ))}
        </Stack>
    );
};

const sourceLabel: Record<ContentSource, string> = {
    [ContentSource.Buzz]: "Buzz",
    [ContentSource.Shreq]: "Shreq",
    [ContentSource.Sprint]: "Sprint"
};

const sourceBadgeColor: Record<ContentSource, number> = {
    [ContentSource.Buzz]: BadgeColor.LightBlue,
    [ContentSource.Shreq]: BadgeColor.LightGreen,
    [ContentSource.Sprint]: BadgeColor.Gray
};
